import './preRequest';
import {Profiler, StrictMode} from 'react';
import ReactDOM from 'react-dom';

/**
 * 注意样式导入的顺序，会影响样式的权重
 */
import '@baidu/luffy/style/index.css';
// rte有包含部分luffy组件样式
import '@baidu/realtime-editor/dist/index.css';
import '@/style/overwrite-luffy.scss';
import './index.css';

import TocApp from './tocPages/TocApp';
import sdk from './sdk';
import * as store from '@/store';
import '@/eventBus/kuJSSDK';
import {initVariables} from './style/Theme';
import {getDocumentInfo, getRepositoryInfo} from '@/services';
import './bdABTest';

if (process.env.REACT_APP_USE_HTTPS_META) {
    const meta = document.createElement('meta');
    meta.httpEquiv = 'Content-Security-Policy';
    meta.content = 'upgrade-insecure-requests';
    document.getElementsByTagName('head')[0].appendChild(meta);
}

import {getKnowledgePageRouteMatchInfo} from '@/utils/urlUtils';

import kuPiper from './middleware/kuPiper';
// import DocReferenceListPlugin from '@/plugins/DocReferenceListPlugin';
// import BaikePlugin from '@/plugins/BaikePlugin';
// import RecommendReadingPlugin from '@/plugins/RecommendReadingPlugin';
// import ICafeListPlugin from '@/plugins/ICafeListPlugin';
// import KuSharePlugin from '@/plugins/KuSharePlugin';
// import SquareRecommendPagePlugin from '@/plugins/SquareRecommendPagePlugin';
import AIChatPlugin from '@/tocPages/plugins/DocPanelPlugin';
// import kuToolPlugin from '@/plugins/KuToolPlugin';
// import KuSearchPlugin from './plugins/KuSearchPlugin';
// import EditorSmallFlowPlugin from '@/plugins/EditorSmallFlowPlugin';
// import SuperAdminRestrictPlugin from '@/plugins/SuperAdminRestrictPlugin';
import TocPlugin from '@/tocPages/plugins/TocPlugin';
import {perfLogger, PROFILER_KEY} from '@/buried/performance';
import {getDevice} from '@/utils/browserUtils';
import MobileTip from '@/tocPages/components/MobileTip';


window.isTocPage = true;

// 注册自定义插件
kuPiper.registerPlugins([
    new TocPlugin(),
    // new DocReferenceListPlugin(),
    // new RecommendReadingPlugin(),
    // new BaikePlugin(),
    // new ICafeListPlugin(),
    // // new AITemplatesPlugin(),
    new AIChatPlugin(),
    // new kuToolPlugin(),
    // new KuSearchPlugin(),
    // new EditorSmallFlowPlugin(),
    // new SuperAdminRestrictPlugin(),
]);


initVariables();


const init = () => {
    const {
        isKnowledgePage,
        isDocPage,
        spaceGuid,
        groupGuid,
        repositoryGuid,
        docGuid,
    } = getKnowledgePageRouteMatchInfo();
    if (!(isKnowledgePage && isDocPage)) {
        store.setDocReady(true);
    }
    // 知识库页面
    if (isKnowledgePage) {
        const repository = {
            spaceGuid,
            groupGuid,
            repositoryGuid,
        };
        if (isDocPage) {
            getDocumentInfo({
                ...repository,
                docGuid,
            });
        } else {
            getRepositoryInfo(repository);
        }
        return;
    }
    // 非知识库页面
    if (!sdk.user) {
        sdk.autoLogin();
    }
};

const device = getDevice();
const isMobile = device.platform === 'mobile';
const isNotForbiddenPage = !['/403', '/hidden', '/login'].includes(location.pathname);
if (isNotForbiddenPage && !isMobile) {
    init();
}


function renderApp() {
    setTimeout(() => {
        console.log('ReactDOM.render----------------');
        ReactDOM.render(
            <StrictMode>
                <Profiler id={PROFILER_KEY.app} onRender={perfLogger.compRender.onRender}>
                    {isMobile ? <MobileTip /> : <TocApp />}
                </Profiler>
            </StrictMode>,
            document.getElementById('root')
        );
    }, 0);
}

renderApp();
